import { Button } from '@material-ui/core';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import React, { SetStateAction, VFC } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { makeSelectAccountId } from 'containers/Auth_old/selectors';
import usePusherChannel from 'hooks/usePusherChannel';

import { SelectedFilters } from '../Filters';
import { messages } from './messages';
import { useStyles } from './styles';

interface LoadMoreProps {
  showLoadMore: boolean;
  setShowLoadMore: (flag: boolean) => void;
  setIsRefetch: (flag: boolean) => void;
  setSelectedFilters: React.Dispatch<SetStateAction<SelectedFilters>>;
}

interface PusherChatBotData {
  /* eslint-disable camelcase */
  bot_type: string;
  /* eslint-enable */
}

export const LoadMore: VFC<LoadMoreProps> = ({
  showLoadMore,
  setShowLoadMore,
  setSelectedFilters,
  setIsRefetch,
}) => {
  const styles = useStyles();
  const intl = useIntl();
  const accountExternalId = useSelector(makeSelectAccountId());

  const accountInboundChatBotLog = (data: PusherChatBotData) => {
    const params = new URLSearchParams(window.location.search);
    const botType = params.get('botType');
    if (data.bot_type === 'All' && ['All', null].includes(botType))
      setShowLoadMore(true);
    if (data.bot_type === botType) setShowLoadMore(true);
  };

  usePusherChannel(`${accountExternalId}-chatbot-review`, {
    'inbound:chatBotLog': accountInboundChatBotLog,
  });

  const handleLoadMore = () => {
    setIsRefetch(true);
    setShowLoadMore(false);
    setSelectedFilters({
      status: 'All',
      models: [],
      intents: [],
      sortBy: 'Newest',
    });
  };

  if (!showLoadMore) {
    return null;
  }

  return (
    <Button
      variant="contained"
      color="primary"
      className={styles.loadMore}
      onClick={handleLoadMore}
    >
      <AutorenewIcon className={styles.loadMoreIcon} />
      {intl.formatMessage(messages.loadMore)}
    </Button>
  );
};
